export interface ClientLanding {
  redirectTo: string;
}

/**
 * Landing rule for external (client) users at the app root.
 *
 * - External + exactly one project  -> redirect to that project's dashboard.
 * - External + zero or many projects -> null (fall through to the Accounts list).
 * - Internal users                   -> null (unchanged behaviour).
 *
 * Returns null for any non-array / empty input so a client never redirects to
 * `/projects/undefined`. Project ids are used verbatim in the path; the login
 * redirect already relies on `projectId[0]` being a plain id.
 */
export const clientLanding = (
  isExternal: boolean,
  projectIds: Array<number | string> | null | undefined
): ClientLanding | null => {
  if (!isExternal) return null;
  if (!Array.isArray(projectIds)) return null;
  if (projectIds.length !== 1) return null;
  return { redirectTo: `/projects/${projectIds[0]}` };
};
